import React from 'react';

/**
 * Страница, содержащая сообщение об ошибке
 * @returns {JSX.Element}
 * @constructor
 */
const ErrorPage = () => {
    return (
        <div>
            <h1>Oops, something is wrong...</h1>
        </div>
    );
};

export default ErrorPage;